export default __webpack_public_path__ + "static/iLFI-1e3bd7327bdf7d233a976d1d25f7732d.jpg";